import * as React from "react";
import { FormField } from "./FormField.jsx";
// import * as cls from "./ComboBox.module.scss";
export { ComboBox };
/**
 * Комбинированный список.
 *
 * Представляет элемент управления выбором, который объединяет
 * нередактируемое текстовое поле и раскрывающееся поле,
 * позволяющее пользователям выбирать элемент из списка.
 * 
 * @summary Комбинированный список.
 * @param {Object} props - Атрибуты элемента.
 * @param {React.RefObject} [props.inputRef] - Ссылка на элемент `input`.
 * @param {string} [props.id] - Идентификатор поля.
 * Задаёт атрибуты `name` и `id`.
 * @param {string} [props.label] - Название и описание поля.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @param {boolean} [props.required] - Обязательное для заполнения.
 * @param {boolean} [props.disabled] - Неактивно.
 * @param {boolean} [props.uncontrolled] - Неуправляемый компонент.
 * @param {boolean} [props.autoComplete] - Разрешено ли автозаполнение.
 * @param {Object|Array} props.dictionary - 
 * Словарь {надпись: значение} или массив значений.
 * @param {string} [props.value] - Значение.
 * @param {EventListener} [props.onChange] - Событие при изменении.
 * @returns {JSX.Element} Элемент JSX.
 * @see {@link ../frame/EventListener.js}
 * @see [Windows.UI.Xaml.Controls.ComboBox](https://learn.microsoft.com/ru-ru/uwp/api/windows.ui.xaml.controls.combobox)
 * @see [Комбинированный список](https://ru.wikipedia.org/wiki/Комбинированный_список)
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function ComboBox(
  {
    inputRef,
    id,
    label,
    className,
    required,
    disabled,
    uncontrolled,
    autoComplete,
    dictionary = [],
    value,
    onChange
  }) {
  const options = renderComboBoxOptionList(dictionary, value);
  return (
    <FormField
      label={label}
      labelFor={id}
      required={required}
      className={className}>
      <select
        ref={inputRef}
        id={id}
        name={id}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        value={uncontrolled ? undefined : value}
        onChange={onChange}>
        {options}
      </select>
    </FormField>
  );
}
// Отображает опцию для ComboBox
function renderComboBoxOption(key, value) {
  return <option key={key} value={value}>{key}</option>;
}
// Отображает список опций для ComboBox
function renderComboBoxOptionList(dictionary) {
  const keyList = Array.isArray(dictionary) ? dictionary :
    Object.keys(dictionary);
  const valueList = Array.isArray(dictionary) ? dictionary :
    Object.values(dictionary);
  return keyList.map((key, i) => renderComboBoxOption(key, valueList[i]));
}
